import { SEARCH_TERM, TEXT_SEARCH } from '../constants';
import getFilterValueFromQuery from './get-filter-value-from-query';

const getFilterValues = (filterData, filters, query) => {
  const filterValues = {};
  filterValues[SEARCH_TERM] = query[SEARCH_TERM] || '';

  filters.forEach(filterProps => {
    const {
      propsToDisplay: [key],
      type
    } = filterProps;
    if (type === TEXT_SEARCH) return;
    const data = filterData && filterData[key] ? filterData[key] : {};
    filterValues[key] = getFilterValueFromQuery(key, filterProps, data, query);
  });
  filterValues.dataNotSet = !filterData;
  return filterValues;
};

export default getFilterValues;
